import html2canvas from "html2canvas";
import jsPDF from 'jspdf';

const exportAsImage = async (el, imageFileName) => {
    const canvas = await html2canvas(el);
    const image = canvas.toDataURL("image/png", 1.0);
    downloadImage(image, imageFileName);
};

const exportAsImageDev = async (el) => {
    const canvas = await html2canvas(el);
    return canvas.toDataURL("image/png", 1.0);
}

const downloadImage = (blob, fileName) => {
    const fakeLink = window.document.createElement("a");
    fakeLink.style = "display:none;";
    fakeLink.download = fileName;
    fakeLink.href = blob;
    document.body.appendChild(fakeLink);
    fakeLink.click();
    document.body.removeChild(fakeLink);
    fakeLink.remove();
};

export const downloadPDF = async (elements, setProgress) => {
    elements = elements.filter(el => el !== null);

    if (elements.length === 0) {
        console.warn("No elements to export.");
        return;
    }

    const pdf = new jsPDF('landscape');
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const totalElements = elements.length;

    let validImageCount = 0;

    for (const [index, el] of elements.entries()) {
        try {
            const element = el.getElement ? el.getElement() : el;
            
            if (!element) {
                console.warn(`Element at index ${index} is null`);
                continue;
            }

            if (!document.body.contains(element)) {
                console.warn(`Element at index ${index} is not in document`);
                continue;
            }

            console.log(`Capturing element ${index}...`);
            
            const image = await exportAsImageDev(element);
            
            if (!image) {
                console.warn(`Failed to generate image for element ${index}`);
                continue;
            }

            const imgProps = pdf.getImageProperties(image);
            const ratio = pdfWidth / imgProps.width;
            const imgHeight = imgProps.height * ratio;

            // Add new page only if we've already added at least one valid image
            if (validImageCount > 0) {
                pdf.addPage();
            }

            pdf.addImage(image, 'PNG', 0, 0, pdfWidth, imgHeight);
            validImageCount++;
            
            console.log(`Successfully added element ${index} to PDF`);
            
        } catch (error) {
            console.error(`Error processing element ${index}:`, error);
        }
        
        setProgress(Math.round(((index + 1) / totalElements) * 100));
    }

    if (validImageCount === 0) {
        alert("No valid elements could be captured!");
        setProgress(0);
        return;
    }

    if (window && window?.flutter_inappwebview) {
        const blob = pdf.output('blob');
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = function () {
            const base64data = reader.result.split(',')[1];
            window.flutter_inappwebview.callHandler('downloadFileWithBase64', base64data, 'document.pdf');
        }
    } else {
        pdf.save("document.pdf");
    }

    setProgress(0);
};

export default exportAsImage;


